// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e011cf9f","732":"4d04814b","977":"6600d978"}[chunkId] + ".chunk.js";
};